var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vi-tabs__nav-wrap",class:[
  _vm.rootTabs.tabPosition ? ("is-" + (_vm.rootTabs.tabPosition)) : ''
  ]},_vm._l((_vm.panes),function(pane,index){return _c('div',{key:index,staticClass:"vi-tabs__item",class:[
      _vm.rootTabs.tabPosition ? ("is-" + (_vm.rootTabs.tabPosition)) : '',
      {
        'is-active': pane.active,
        'is-disabled': pane.disabled,
      }
    ],on:{"click":function($event){_vm.clickTab($event, pane, index)}}},[_vm._v("\n    "+_vm._s(pane.label)+"\n  ")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bef7c00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/tabs/src/tab-nav.vue
// module id = null
// module chunks = 